/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import HomeIcon from '@material-ui/icons/HomeOutlined';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import PeopleIcon from '@material-ui/icons/PeopleOutline';
import CardsIcon from '@material-ui/icons/FolderOpenOutlined';
import AdsIcon from '@material-ui/icons/Adjust';
import ProfileIcon from '@material-ui/icons/Person';

const navConfig = [
  {
    items: [
      {
        title: 'מבט על',
        href: '/admin/overview',
        icon: HomeIcon,
      },

      {
        title: 'לקוחות',
        href: '/admin/customers',
        icon: PeopleIcon,
      },

      {
        title: 'כרטיסים',
        href: '/admin/cards',
        icon: CardsIcon,
      },
      { title: 'מודעות', href: '/admin/ads', icon: AdsIcon },
      { title: 'פרופיל', href: '/admin/profile', icon: ProfileIcon },

      {
        title: 'הגדרות',
        href: '/admin/settings',
        icon: SettingsIcon,
      },
      { title: 'תקנון שימוש', href: '/terms-of-service' },
    ],
  },
];

export default navConfig;
